import { LibraryTraces_TraceId, Platform, } from './generated/confidence/telemetry/v1/telemetry';
export class Telemetry {
    disabled;
    logger;
    libraryTraces = [];
    platform;
    constructor(opts) {
        this.disabled = opts.disabled;
        this.logger = opts.logger;
        this.platform = opts.environment === 'client' ? Platform.PLATFORM_JS_WEB : Platform.PLATFORM_JS_SERVER;
    }
    registerLibraryTraces({ library, version, id }) {
        if (this.disabled) {
            return () => { };
        }
        const traces = [];
        this.libraryTraces.push({
            library: library,
            libraryVersion: version,
            traces,
        });
        return data => {
            this.logger?.debug?.(LibraryTraces_TraceId[id], data);
            traces.push({
                id,
                ...data,
            });
        };
    }
    getSnapshot() {
        const libraryTraces = this.libraryTraces
            .filter(({ traces }) => traces.length > 0)
            .map(({ library, libraryVersion, traces }) => ({
            library,
            libraryVersion,
            traces: traces.splice(0, traces.length),
        }));
        return { libraryTraces, platform: this.platform };
    }
}
//# sourceMappingURL=Telemetry.js.map